import { Container, LoadingOverlay } from '@soteria/design-system-ve';

/**
 * Component displayed when community group details are loading
 */
export function CommunityGroupLoadingState() {
  return (
    <Container padding="xxlarge" size="xxl">
      <LoadingOverlay message="Loading community group..." />
    </Container>
  );
}
